// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"16":"assets/themes/bkw-old/css/mail/default","221":"assets/themes/bkw-old/css/app.be","641":"assets/themes/bkw-old/css/app.fe"}[chunkId] + ".css";
};